import Vue from "vue";
import axios from "axios";

export const setBaseUrl = (apiServer) => {
  return apiServer || `https://${process.env.VUE_APP_PROD_URL}`
}

export const setAuthorizationHeader = (access_token) => {
  axios.defaults.headers.common.Authorization = `Bearer ${access_token}`
}

Vue.prototype.$http = axios
Vue.prototype.$http.defaults.baseURL = setBaseUrl()
Vue.prototype.$http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
